import * as mainActionTypes from '../mainActionTypes';

export default function selectedNameReducer(state = { selectedIndex: -1 }, action) {
  const { type, payload } = action;
  let newState = state;
  switch (type) {
    case mainActionTypes.SET_SELECTED_NAME:
      newState = { ...state, selectedIndex: payload };
      break;

    case mainActionTypes.SET_NAMES_LIST:
      newState = { ...state, selectedIndex: -1 };
      break;
    default:
  }

  return newState;
}
